import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PolylineOverlay from "../overlays/PolylineOverlay";
import { Marker, Popup } from "react-map-gl";
import { Typography, Card, CardContent, Grid } from "@material-ui/core";
import { isValidCoordinates } from "../helper/LatLonValidation";

const styles = (theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
  marker: {
    zIndex: 1,
  },
  lines: {
    zIndex: 0,
  },
  title: {
    textAlign: "center",
  },
  popup: {
    zIndex: 2,
    marginTop: "-50px",
  },
  popupContent: {
    width: "650px",
  },
  infoImage: {
    width: "100%",
  },
  infoRow: {
    borderBottom: "solid #ccc 1px",
    paddingBottom: "5px",
    paddingTop: "5px",
  },
  infoTitle: {
    width: "30%",
    display: "inline-block",
    verticalAlign: "top",
  },
  infoDesciption: {
    width: "70%",
    display: "inline-block",
    verticalAlign: "top",
  },
  infoLeftBox: {
    marginTop: "10px",
    border: "solid #ccc 1px",
    borderRight: "none",
  },
  infoRightBox: {
    marginTop: "10px",
    border: "solid #ccc 1px",
  },
  subTitle: {
    fontWeight: "bold",
    marginTop: "10px",
  },
  infoUrlContainer: {
    marginTop: "10px",
  },
  infoUrl: {
    marginTop: "15px",
    paddingLeft: "5px",
    paddingRight: "5px",
    borderRight: "1px solid #ccc",
  },
});

class Property extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowPopup: false,
    };
  }
  
  _onPropertyClick = (event) => {
    if (event.nativeEvent) {
      event.nativeEvent.preventDefault();
      event.nativeEvent.stopPropagation();
    }
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      isShowPopup: true,
    });
  };

  _onClosePopup = (event) => {
    this.setState({
      isShowPopup: false,
    });
  };
  
  _checkValidPositions = () => {
    const { longitude, latitude, data } = this.props;
    const isMainLocationValid = isValidCoordinates(longitude, latitude);
    let isAllDataValid = true;
    if (data.length) {
      isAllDataValid = data.every((ai) =>
        isValidCoordinates(data.longitude, data.latitude)
      );
    }
    return isMainLocationValid && isAllDataValid;
  };
  render() {
    const isDataValid = this._checkValidPositions();
    if (!isDataValid) {
      console.log("data positions is not valid !");
      console.log(this.props);
      return null;
    }

    const { isShowPopup } = this.state;
    const {
      id,
      longitude,
      latitude,
      data,
      iconUrl,
      showMarker,
      classes,
      toolTip,
    } = this.props;
    const havingPositions = !!data && data.positions;
    const points =
      havingPositions && data.positions.length > 1
        ? [...data.positions, data.positions[0]]
        : [];

    const customId = id ? id : '0' ;
    return (
      <div>
        <div>
          {isShowPopup ? (
            <Popup
              className={classes.popup}
              tipSize={5}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              longitude={longitude}
              latitude={latitude}
              closeOnClick={false}
              onClose={(event) => this._onClosePopup()}
            >
              <Card className={classes.popupContent}>
                <CardContent className={"popup-property popup-property-id" + customId }>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    className={classes.title}
                  >
                    {data.title}
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={4} className={classes.infoLeftBox}>
                      {data.imageUrl ? (
                        <img
                          className={classes.infoImage}
                          alt=""
                          src={data.imageUrl}
                        ></img>
                      ) : null}
                      {data.subTitle ? (
                        <div className={classes.subTitle}>{data.subTitle}</div>
                      ) : null}

                      {data.urls ? (
                        <div className={classes.infoUrlContainer}>
                          {data.urls.map((urlData, index) => (
                            <a
                              key={index}
                              className={classes.infoUrl}
                              alt={urlData.title}
                              href={urlData.url}
                              target="blank"
                            >
                              {urlData.title}
                            </a>
                          ))}
                        </div>
                      ) : null}
                    </Grid>

                    <Grid item xs={8} className={classes.infoRightBox}>
                      {data.lables
                        ? data.lables.map((lableData, index) => {
                            return (
                              <div className={classes.infoRow} key={index}>
                                <div className={classes.infoTitle}>
                                  {lableData.title}
                                </div>
                                <div className={classes.infoDesciption}>
                                  {lableData.description}
                                </div>
                              </div>
                            );
                          })
                        : null}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Popup>
          ) : null}
        </div>
        <div className={classes.lines}>
          {havingPositions ? <PolylineOverlay points={points} /> : null}
        </div>

        {showMarker ? (
          <Marker
            tracksViewChanges={false}
            longitude={longitude}
            latitude={latitude}
            draggable={false}
            width="50"
            height="50"
            offsetTop={-50}
            offsetLeft={-10}
            className={classes.marker}
            captureClick={true}
          >
            {toolTip ? <span className="map-marker-tooltip">{toolTip}</span> : null}

            <div>
              <img
                src={iconUrl}
                className="leaflet-marker-icon grow"
                alt=""
                onClick={(event) => this._onPropertyClick(event)}
              />
            </div>
          </Marker>
        ) : null}
      </div>
    );
  }
}
export default withStyles(styles)(Property);
